import { DEG_TO_RAD } from './constants';

export default function rad(degrees) {
    return degrees * DEG_TO_RAD;
}



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/util/rad.js
// module id = ../../../../@progress/kendo-drawing/dist/es/util/rad.js
// module chunks = vendor